/**
 * AppealUserReportContent
 *
 * Content component for the AppealUserReportSheet.
 * Mirrors Flutter's UserReportAppealScreen layout
 * (lib/presentation/screens/user/user_report_appeal_screen.dart).
 * Thin wrapper composing useAppealUserReport with the shared
 * AppealReportContent layout.
 */

import React from 'react';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { AppealReportContent } from '@/presentation/components/common/appealReport/AppealReportContent';
import { useAppealUserReport } from '../hooks/useAppealUserReport';

export interface AppealUserReportContentProps {
  onFinish: () => void;
}

export const AppealUserReportContent: React.FC<AppealUserReportContentProps> = ({ onFinish }) => {
  const { l10n } = useLocale();

  const { comment, isSubmitting, hasCommentError, setComment, handleSubmit } = useAppealUserReport({ onFinish });

  return (
    <AppealReportContent
      title={l10n.appealUserReport.title}
      subtitle={l10n.appealUserReport.subtitle}
      description={l10n.appealUserReport.description}
      commentPlaceholder={l10n.appealUserReport.commentPlaceholder}
      emptyCommentError={l10n.appealUserReport.emptyCommentError}
      submitLabel={l10n.appealUserReport.submit}
      comment={comment}
      isSubmitting={isSubmitting}
      hasCommentError={hasCommentError}
      setComment={setComment}
      onClose={onFinish}
      onSubmit={handleSubmit}
    />
  );
};
